export const ADD_MESSAGE = 'ADD_MESSAGE'
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE'
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES'
export const UPDATE_NAVIGATION = 'UPDATE_NAVIGATION'
export const SAVE_URI_STATE = 'SAVE_URI_STATE';


// WEBPACK FOOTER //
// ./src/app/redux-action-types.js